import styled, { css } from "styled-components"
import media from "src/styles/media"

export const Button = styled.button`
    font-weight: 400;
    border-radius: 30px;
    padding: 6px 27px;
    background-color: ${props => `var(--${props.color});`};
    color: var(--white);
    transition: all 0.4s;
    border: 1px solid transparent;

    &:disabled{
        opacity: .6 !important;
    }

    &:hover{
        transform: scale(1.04);
    }

    svg{
        display: inline-block;
        margin-left: 4px;
        margin-right: -5px;
        height: 18px;
        margin-bottom: 2px;
    }

    /* VARIANT OUTLINE */
    ${props =>
      props.variant === "outline" &&
      css`
        color: var(-- ${props.color});
        background-color: transparent;
        border: 1.2px solid var(-- ${props.color});

        &:hover {
          background-color: var(-- ${props.color});
          color: var(-- ${props.color === "white" ? "dark" : "white"});
        }
      `}

    /* SIZE LG */
    ${props =>
      props.size === "lg" &&
      css`
        font-size: 18px;
        padding: 8px 34px;

        svg {
          margin-right: 5px;
          margin-left: -2px;
          height: 23px;
          margin-bottom: 4px;

          &.icon-after {
            margin-right: -2px;
            height: 19px;
            margin-left: 6px;
            margin-bottom: 2px;
          }
        }
      `}

    ${media.lessThan("lg")`
        ${props =>
          props.size === "lg" &&
          css`
            font-size: 16px;
          `}
    `}

    /* SIZE SM */

    ${props =>
      props.size === "sm" &&
      css`
        font-size: 16px;
        padding: 4px 17px;
      `}

    ${media.lessThan("sm")`
        ${props =>
          props.size === "sm" &&
          css`
            font-size: 15px;
          `}
    `}
`
